var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c(
        "div",
        {
          staticClass: "title-box acea-row row-between row-middle",
          style: _vm.boxStyle,
        },
        [
          _c("div", { staticClass: "acea-row row-middle" }, [
            _c("div", { style: _vm.titleStyle }, [
              _vm._v(_vm._s(_vm.titleTxt)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ml6", style: _vm.titleFuStyle }, [
              _vm._v(_vm._s(_vm.titleFuTxt)),
            ]),
          ]),
          _vm._v(" "),
          !_vm.selectShow
            ? _c("div", { style: _vm.titleRightStyle }, [
                _vm._v(_vm._s(_vm.titleRightTxt)),
                _c("i", { staticClass: "el-icon-arrow-right" }),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }